import React from 'react';
// import logo from '../../images/logo.svg';
// import Link from 'react-router-dom/Link';
import { Row, Col, Anchor} from 'antd';
import './UpdatesHeader.css';

const UpdatesHeader = (props) => {
   return (
      <div className="UpdatesHeader--container">

        <div className="UpdatesHeader--subnavbar-container">
          <div className="UpdatesHeader--subnavbar center">
          </div>  
          <h2 className="UpdatesHeader--subnavbar-headline font-special-heading">Real Time Touch: USPTO-Granted Patent Highlights</h2>
        </div>

      <div className="UpdatesHeader--container-inner">

        <div className="UpdatesHeader--headline">
        <h3 font-special-heading>
            Latest Updates & Press Releases
         </h3>
          
       </div>
       <div className="UpdatesHeader--body-text">


         <Row className="UpdatesHeader--row1">
          <Col sm={24} md={8}>
            <div className="UpdatesHeader--img-holder">
              <Anchor affix={false} offsetTop="70">
                <Anchor.Link href="#Press-Releases" title={<img 
                  alt="Press Releases"
                  className="UpdatesHeader--img img-responsive img-rounded-more" 
                  src="https://www.realtimetouch.com/images/500/honeycomb-3143432_1920.jpg" 
                />
              } />
              </Anchor>
              <div className="clearfix UpdatesHeader-text-subimg">Press Releases</div>
            </div>   
          </Col> 
          <Col sm={24} md={8}>
            <div className="UpdatesHeader--img-holder">
              <Anchor affix={false} offsetTop="70">
                  <Anchor.Link href="#Twitter" title={<img 
                    className="UpdatesHeader--img img-responsive img-rounded-more" 
                    src="https://www.realtimetouch.com/images/500/Twitter_Logo_Hd_Png_07.png" 
                    alt="Social Media"
                  />
                } />
              </Anchor>
              <div className="clearfix UpdatesHeader-text-subimg">Twitter Highlights</div>
            </div>       
          </Col>
          <Col sm={24} md={8}>
            <div className="UpdatesHeader--img-holder">
              <Anchor affix={false} offsetTop="70">
                <Anchor.Link href="#Social-Media" title={<img 
                  className="UpdatesHeader--img img-responsive img-rounded-more" 
                  src="https://www.realtimetouch.com/images/500/social-media-3129481_1280.jpg"
                  alt="Social Media"
                />
              } />
              </Anchor>
              <div className="clearfix UpdatesHeader-text-subimg">Social Media Feeds</div>
            </div>   
          </Col>
        </Row>
       </div>
      </div>
      </div>
    )
 }
 export default UpdatesHeader;


// WEBPACK FOOTER //
// ./src/containers/UpdatesHeader/UpdatesHeader.js